export const GET_ERRORS = "GET_ERRORS";
export const CLEAR_ERRORS = "CLEAR_ERRORS";
export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const GET_USERS = "GET_USERS";
export const PROFILE_LOADING = "PROFILE_LOADING";
export const PROFILE_NOT_FOUND = "PROFILE_NOT_FOUND";
export const CLEAR_CURRENT_USER = "CLEAR_CURRENT_USER";
export const GET_PROFILES = "GET_PROFILES";
export const POST_LOADING = "POST_LOADING";
export const GET_POSTS = "GET_POSTS";
export const GET_POST = "GET_POST";
export const ADD_POST = "ADD_POST";
export const DELETE_POST = "DELETE_POST";
export const GET_ADMIN_USERS = "GET_ADMIN_USERS";
export const GET_STATS = "GET_STATS";
export const GET_PROPERTY = "GET_PROPERTY";
export const GET_SINGLE_PROPERTY = "GET_SINGLE_PROPERTY";



// WEBPACK FOOTER //
// ./src/actions/types.js